import { Modal, notification } from "antd"
import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import moment from "moment"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { MdAdd, MdDelete, MdEdit, MdSend, MdUpload } from "react-icons/md"
import { SiTicktick } from "react-icons/si"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Swal from "sweetalert2"
import axios from "axios"
import Loader from "pages/Loader"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { IoMdWarning } from "react-icons/io"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { CloseOutlined } from "@ant-design/icons"
import { RiArrowUpDownFill } from "react-icons/ri"

const CustomerIndex = () => {
  document.title = "Customers | Return First Investments"

  const { checkAccess } = usePermissionData()

  const Navigate = useNavigate()
  const [Loading, setLoading] = useState(false)
  const [Data, setData] = useState([])
  const [Users, setUsers] = useState([])
  const [AddModal, setModal] = useState(false)
  const [portfolios, setportfolios] = useState(null)
  const [clientCode, setclientCode] = useState("")
  const fileInputRef = useRef()

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`customer-management`)
      if (response?.data?.success) {
        const sortedData = response?.data?.data?.slice()?.sort((a, b) => {
          const aValue = (a.clientId || "").toLowerCase()
          const bValue = (b.clientId || "").toLowerCase()
          return aValue.localeCompare(bValue)
        })

        setUsers(sortedData)
        setData([...sortedData].reverse())
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Users.filter(
      session =>
        session.clientId.toLowerCase().includes(e.target.value.toLowerCase()) ||
        session.customerName
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session.email.toLowerCase().includes(e.target.value.toLowerCase()) ||
        session?.contactNumber
          ?.toLowerCase()
          .includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const handleDelete = async id => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Customer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    })

    if (result.isConfirmed) {
      try {
        const response = await axiosbaseurl.delete(`/customer-management/${id}`) // Use correct API endpoint

        if (response?.data?.success) {
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">
                  Customer Deleted Successfully.
                </div>
              </div>
            ),
            placement: "topRight",
          })

          // Refresh user list after delete
          getData()
        }
      } catch (error) {
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: error?.response?.data?.message,
        })
      }
    }
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const handleUpload = async () => {
    if (!portfolios) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Please select a file to upload</div>
          </div>
        ),
      })

      return
    }
    if (
      portfolios.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      portfolios.type !== "application/vnd.ms-excel"
    ) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Only .xls & .xlsx files are allowed.</div>
          </div>
        ),
      })

      return
    }

    setModal(false)

    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("clientCode", clientCode)
      formData.append("PCDSheet", portfolios)

      const response = await axiosbaseurl.post(
        `customer-management/upload/PCD-sheet-data`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      if (response?.data?.success) {
        setLoading(false)
        setportfolios()
        fileInputRef.current.value = ""
        notification.open({
          message: (
            <div className="d-flex align-items-center">
              <div className="pr-20">
                <SiTicktick className="text-success fs-4 me-2" />
              </div>
              <div className="succes-message">{response?.data?.message}</div>
            </div>
          ),
          placement: "topRight",
        })
      } else {
        setLoading(false)
        setportfolios()
        fileInputRef.current.value = ""
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
        })
      }
    } catch (e) {
      setLoading(false)
      setportfolios()
      fileInputRef.current.value = ""
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: e?.response?.data?.message,
      })
    }
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  // Sorting logic using useMemo for performance
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return Data

    const sortableItems = [...Data]
    sortableItems.sort((a, b) => {
      let aValue, bValue

      switch (sortConfig.key) {
        case "customerName":
          aValue = (a.customerName || "").toLowerCase()
          bValue = (b.customerName || "").toLowerCase()
          break
        case "email":
          aValue = (a.email || "").toLowerCase()
          bValue = (b.email || "").toLowerCase()
          break
        case "clientid":
          aValue = (a.clientId || "").toLowerCase()
          bValue = (b.clientId || "").toLowerCase()
          break
        case "totalInvestedAmount":
          aValue = Number(a.totalInvestedAmount) || 0
          bValue = Number(b.totalInvestedAmount) || 0
          break
        default:
          aValue = a[sortConfig.key]
          bValue = b[sortConfig.key]
      }

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sortableItems
  }, [Data, sortConfig])

  // Slice for pagination
  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  // Sort request handler
  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(3, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Customers"} />

            <div className="card p-2 py-3">
              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="search-box position-relative">
                    <input
                      className="form-control form-control1 ps-6"
                      placeholder="Search Customer"
                      onChange={filterByName}
                    />
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                  <select
                    className="form-select form-select1 ms-3 fs-6 rounded-5"
                    value={items_perpage}
                    onChange={e => setItemsPerPage(e.target.value)}
                    style={{ width: "110px" }}
                  >
                    <option value="5">Show 5</option>
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="30">Show 30</option>
                  </select>
                </div>

                <div>
                  {checkAccess(3, 2) && (
                    <button
                      className="btn Add-Button rounded-5"
                      onClick={() =>
                        Navigate(`${ConfigUrl.appurl}add-customer`)
                      }
                    >
                      <MdAdd /> Add Customer
                    </button>
                  )}
                </div>
              </div>

              <div className="table-responsive mt-4">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>

                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("clientid")}
                      >
                        Client ID{" "}
                        {sortConfig.key === "clientid" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>

                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("customerName")}
                      >
                        Name{" "}
                        {sortConfig.key === "customerName" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>

                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("email")}
                      >
                        Email{" "}
                        {sortConfig.key === "email" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>

                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("totalInvestedAmount")}
                      >
                        Initial Capital{" "}
                        {sortConfig.key === "totalInvestedAmount" ? (
                          sortConfig.direction === "ascending" ? (
                            "▲"
                          ) : (
                            "▼"
                          )
                        ) : (
                          <RiArrowUpDownFill size={18} />
                        )}
                      </th>

                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.clientId}</td>
                        <td>{item?.customerName}</td>
                        <td>{item?.email}</td>
                        <td>
                          {item?.totalInvestedAmount
                            ? `₹ ${item?.totalInvestedAmount}`
                            : "--"}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center">
                            {checkAccess(3, 3) && (
                              <>
                                <button
                                  className="btn Edit-Button me-2 rounded-5"
                                  onClick={() =>
                                    Navigate(
                                      `${ConfigUrl.appurl}edit-customer/${item?.id}`
                                    )
                                  }
                                >
                                  <MdEdit /> Edit
                                </button>
                                <button
                                  className="btn export-Button me-2 rounded-5"
                                  onClick={() => {
                                    setclientCode(item?.clientId)
                                    setModal(true)
                                  }}
                                >
                                  <MdUpload /> Import
                                </button>
                              </>
                            )}
                            {checkAccess(3, 4) && (
                              <button
                                className="btn delete-Button rounded-5"
                                onClick={() => handleDelete(item?.id)}
                              >
                                <MdDelete /> Delete
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="text-center">
                {final_data?.length < 1
                  ? "No customer available at this moment !"
                  : ""}
              </div>

              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-7">
                  Showing {final_data?.length} out of {Data?.length} customers.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
      <Modal
        open={AddModal}
        onCancel={() => setModal(false)}
        footer={false}
        width={700}
        style={{ top: 100 }}
        closeIcon={<CloseOutlined style={{ color: "white", fontSize: 20 }} />}
      >
        <div className="Modal-Body mt-4">
          <div className="Card mt-2">
            <h5 className="fw-bold mb-0 ps-3 py-3">Cutomer Portfolio Upload</h5>
            <div className="Instruction">
              <div className="form-group">
                <label className="fw-bold fs-6">
                  Upload File <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  accept=".xlsx , .xls"
                  required
                  ref={fileInputRef}
                  className="form-control"
                  onChange={e => {
                    setportfolios(e.target.files[0])
                  }}
                />
              </div>
              <div className="w-100 d-flex justify-content-between">
                <div
                  className="btn export-Button mt-3 fs-6 d-flex justify-content-center align-items-center"
                  onClick={() => handleUpload()}
                >
                  <MdUpload className="me-2 fs-4" /> Upload
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default CustomerIndex
